import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { checkRoleUser, getCurrentUser } from '../../../utils/CommonUtil';
import ChevronUp from '../../../assets/icons/ic-chevron-up-w.svg';
import ChevronDown from '../../../assets/icons/ic-chevron-down-w.svg';
import _ from 'lodash';
var MenuItems = function (props) {
    var t = useTranslation().t;
    var currentUser = getCurrentUser();
    var menuItems = props.menuItems, onSelectedItem = props.onSelectedItem;
    var _a = useState([]), menuList = _a[0], setMenuList = _a[1];
    var useOutsideAlerter = function (ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    var menus = menuItems && menuItems.length ? _.cloneDeep(menuItems) : [];
                    if (menus && menus.length) {
                        menus = menus.map(function (menu) {
                            menu.isOpenMenu = false;
                            return menu;
                        });
                        setMenuList(menus);
                    }
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    };
    var parentRef = useRef(null);
    useOutsideAlerter(parentRef);
    useEffect(function () {
        var menus = menuItems && menuItems.length ? _.cloneDeep(menuItems) : [];
        setMenuList(menus);
    }, [menuItems]);
    var onMenuItemClick = function (item) {
        onSelectedItem(item);
    };
    var onClickMenuParent = function (event, index) {
        var menus = _.cloneDeep(menuList);
        if (menus && menus.length) {
            menus[index].isOpenMenu = !menus[index].isOpenMenu;
        }
        setMenuList(menus);
    };
    var onClickChildrentMenu = function (index, indexChild) {
        var menus = _.cloneDeep(menuList);
        if (menus && menus.length) {
            menus[index].isOpenMenu = !menus[index].isOpenMenu;
            menus[index].isSelected = true;
            if (menus[index].parentMenus) {
                menus[index].parentMenus = menus[index].parentMenus.map(function (menu, indexChildMenu) {
                    if (indexChildMenu == indexChild) {
                        menu.isSelected = true;
                    }
                    else {
                        menu.isSelected = false;
                    }
                    return menu;
                });
            }
            onMenuItemClick(menus[index]);
        }
        setMenuList(menus);
    };
    var checkRoleMenu = function (roles) {
        var isValid = true;
        if (currentUser.type == "INTERNAL") {
            isValid = true;
        }
        else {
            isValid = false;
            if (roles && roles.length) {
                roles.forEach(function (role) {
                    if (checkRoleUser(role)) {
                        isValid = true;
                    }
                });
            }
            else {
                isValid = true;
            }
        }
        return isValid;
    };
    return (React.createElement(List, { component: "nav", ref: parentRef },
        React.createElement(ListItem, { component: "div" }, menuList ? menuList.map(function (item, index) {
            if (checkRoleMenu(item.roles) && item.display) {
                return React.createElement(ListItemText, { inset: true, key: 'menu-' + index },
                    item.parentMenus && item.parentMenus.length ?
                        React.createElement("a", { className: "header-item-wrapper", onClick: function (event) { return onClickMenuParent(event, index); } },
                            React.createElement("div", { className: "header-item-link" + (item.isSelected ? " selected" : '') },
                                React.createElement("div", { className: 'header-parent-tem' },
                                    React.createElement("img", { src: item.icon, alt: "ic-dashboard" }),
                                    React.createElement("div", { className: "title" }, t(item.keyName))),
                                React.createElement("img", { src: item.isOpenMenu ? ChevronUp : ChevronDown, alt: "dropdown" }))) :
                        React.createElement("a", { className: "header-item-wrapper", href: item.url },
                            React.createElement("div", { className: "header-item-link" + (item.isSelected ? " selected" : ''), onClick: function () { return onMenuItemClick(item); } },
                                React.createElement("img", { src: item.icon, alt: "ic-dashboard" }),
                                React.createElement("div", { className: "title" }, t(item.keyName)))),
                    item.parentMenus && item.parentMenus.length && item.isOpenMenu ?
                        React.createElement("ul", { className: "btn-menu-options" }, item.parentMenus.map(function (menu, indexChild) {
                            return React.createElement("li", { key: "child-" + indexChild, className: "btn-filter-option " + (menu.isSelected ? "selected-menu" : "") },
                                React.createElement("a", { className: 'content-child-menu', href: menu.url, onClick: function (event) { return onClickChildrentMenu(index, indexChild); } }, t(menu.keyName)));
                        }))
                        : null);
            }
            return null;
        })
            : null)));
};
export default MenuItems;
